<script>
import { layoutMethods, erpUserRolesMethods, erpUserRolesComputed } from "@/state/helpers";
import Swal from 'sweetalert2';
import { getModuleAccess } from '@/router/helper.js'

/**
 * Roles list component
 */
export default {
  page: {
    title: "Roles"
  },
  data() {
    return {
      title: "Roles",
      roles: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        {
          key: "action",
          sortable: false,
        },

        {
          key: "roles",
          sortable: true,
        },
        {
          key: "description",
          sortable: true,
        },
        {
          key: "user_count",
          sortable: false,
        },

        {
          key: "activity",
          sortable: false,
        }
      ],
      submitted: false,
      roleToDelete: 0,
      searchValue: {
        search: null,
        searchField: null,
      },
      searchList: [
        { text: 'Select All', value: null },
        { text: 'Role Name', value: 'r.name' },
        { text: 'Description', value: 'r.description' }
      ],
      refreshPage: false,
      rolesModule: {
				access: {
          create: true,
          read: true,
          update: true,
          delete: true
				}
			}
    };
  },
  computed: {
    ...erpUserRolesComputed,
  },
  mounted: async function () {
    // Set the initial number of items
    this.totalRows = this.rolesListTotalRows;
    this.changeTitle({ title: 'Roles' });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home' } },
        { text: 'Roles', to: { name: 'Roles' } },
      ]
    });
    await this.getRoles();

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Settings', 'User Management', 'Roles')
    .then((access) => this.rolesModule.access = access);


  },
  methods: {
    ...layoutMethods,
    ...erpUserRolesMethods,
    /*
    *  Created by: 	Jero Paolo Balucas
    *  Date:		    November 29, 2022
    *  Description:	getRoles - This function will fetch the list of roles from the database
    *  Params:		  page, rows, search_field, search, sort, sortDesc
    */
    getRoles: async function () {
      await this.getRolesList({
        page: this.searchValue.search == null ? this.currentPage : 1,
        rows: this.refreshPage ? 10 : this.perPage,
        search_field: this.refreshPage ? "" : this.searchValue.searchField,
        search: this.refreshPage ? "" : this.searchValue.search,
        sort: this.refreshPage ? "id" : this.sortBy,
        sortDesc: this.refreshPage ? false : this.sortDesc
      });

      this.searchValue.search = this.refreshPage ? null : this.searchValue.search;
      this.searchValue.searchField = this.refreshPage ? null : this.searchValue.searchField;
      this.refreshPage = false;
    },
    /*
    *  Created by: 	Jero Paolo Balucas
    *  Date:		    November 29, 2022
    *  Description:	addRole - This function will redirect the user to add role page
    */
    addRole() {
      this.$router.push({ path: 'roles/add' });
    },
    /*
    *  Created by: 	Jero Paolo Balucas
    *  Date:		    November 29, 2022
    *  Description:	editRole - This function will redirect the user to edit role page
    *  Params: role id
    */
    editRole(item) {
      this.$router.push({ path: `roles/edit/${item.id}` });
    },
    deleteRole(item) {
      if (!this.rolesModule.access.delete) {
          Swal.fire(
            "Access Restricted",
            "You are not allowed to delete a Role.",
            "warning"
          );
        } else {
          Swal.fire({
              title: 'Are you sure?',
              text: `Do you really want to delete ${item.name}? This process cannot be undone.`,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '##804997',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
          }).then((result) => {
              if (result.isConfirmed) {
                this.manageRole({
                  action: "delete",
                  body: {
                    id: item.id,
                    updatedBy: JSON.parse(localStorage.getItem("userData")).email
                  }
                }).then(async () => {
                  Swal.fire(
                    "Delete Successful!",
                    `${item.name} has been deleted.`,
                    "success"
                  );
                  await this.getRoles();
                }).catch((error) => {
                  Swal.fire("Delete Failed!", `An Error Occured: ${error}`, "danger");
                  console.log(error);
                });
              }else{
                  return;
              }
          })
        }
    },
    /*
    *  Added by: 	  Jero Paolo Balucas
    *  Date:		    December 09, 2022
    *  Description:	tableSorting - This function will sort the list based on role name or description
    *  Params: action
    */
    tableSorting(action) {
      console.log(action)
      switch (action.sortBy) {
        case 'roles':
          this.sortBy = 'r.name';
          break;
        case 'description':
          this.sortBy = 'r.description';
          break;
      }
      this.sortDesc = action.sortDesc;
      this.getRoles();
    },
    showDeletionRestrictedModal() {
      Swal.fire(
        "Access Restricted",
        "You are not allowed to delete a Role.",
        "warning"
      );
    }
  }
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <h5 class="card-title">
                    <span class="text-muted fw-normal ms-2"><b>{{ rolesListTotalRows }} Record(s)</b></span>
                  </h5>
                </div>
              </div>
            </div>
            <!-- end row -->

            <!-- Search and button -->
            <b-row>
              <b-col sm class="mt-2 mb-2">
                <form class="d-flex" @submit.prevent="getRoles()">
                  <b-form-group id="input-group-3" label-for="input-3">
                    <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                      id="input-3" v-model="searchValue.searchField" :options="searchList"></b-form-select>
                  </b-form-group>

                  <b-input-group>
                    <b-form-input v-model="searchValue.search" class="rounded-0"></b-form-input>
                    <b-input-group-append>
                      <b-button variant="primary" type="submit" class="rounded-0 rounded-end px-2">
                        <i class='bx bx-search bx-fw'></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </form>
              </b-col>
              <b-col sm class="mt-2 mb-2">
                <a class="btn btn-secondary" @click="refreshPage = true; getRoles()">
                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; Refresh
                </a>
              </b-col>
              <b-col sm class="mt-2 mb-2">
                <div v-if="rolesModule.access.create" class="d-flex flex-wrap align-items-center justify-content-md-end mt-md-0 gap-2">
                  <a href="javascript:void(0);" class="btn btn-primary" data-bs-toggle="modal" @click="addRole()"><i
                      class="uil uil-plus me-1"></i> Add Role</a>
                </div>
              </b-col>
            </b-row>

            <div class="table-responsive mt-3">
              <div class="table align-middle table-nowrap">
                <b-table :items="rolesList" :fields="fields" responsive="sm" :current-page="currentPage"
                  :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @sort-changed="tableSorting" class="table-check">
                  <!-- <template #head(checkbox)>
                    <div class="form-check font-size-16" width="50px;" @click="checkAll">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="checkAll"
                      />
                      <label class="form-check-label" for="checkAll"></label>
                    </div>
                  </template> -->

                  <template #cell(action)="data">
                    <div class="d-flex">
                      <div class="btn-group me-2 mb-2 mb-sm-0">
                        <!-- <button type="button" class="btn btn-sm btn-primary">
                          <i class="bx bx-show-alt bx-xs bx-fw"></i>
                        </button> -->
                        <button 
                          :disabled="!rolesModule.access.read && !rolesModule.access.update" 
                          type="button" 
                          class="btn btn-sm btn-primary"
                          @click="editRole(data.item)">
                          <i class="bx bx-edit bx-xs bx-fw" ></i>
                        </button>
                      </div>
                      <div>
                        <b-button 
                          :disabled="data.item.user_count > 0" 
                          id="show-btn" 
                          class="btn btn-sm btn-danger"
                          @click="deleteRole(data.item)">
                          <i class="bx bx-trash bx-xs bx-fw"></i>
                        </b-button>
                      </div>
                    </div>
                  </template>

                  <template #cell(roles)="data">
                    <p class="text-body m-0 ">{{ data.item.name }}</p>
                  </template>

                  <template #cell(description)="data">
                    <p class="text-body m-0 ">{{ data.item.description }}</p>
                  </template>

                  <template #cell(user_count)="data">
                    <p class="text-body m-0 ">{{ data.item.user_count }}</p>
                  </template>

                  <template #cell(activity)="data">
                    <!-- <p v-if="data.item.updated_by_name != null" class="small">Modified by: {{ data.item.updated_by_name }}<span class="fw-bold"></span></p> -->
                    <div class="ms-1">
                        <!-- <b-link class="fw-medium" @click="manageUser(data.item)">{{ data.item.name }}
                        </b-link>
                        <p class="text-body fw-small small m-0">
                          {{ data.item.email }}
                        </p> -->
                        <p class="small" style="margin-bottom: 0;">{{ data.item.updated_by_name == null ? 'Created by:' : 'Modified by:' }}</p>
                        <p class="small" style="margin-bottom: 0;"><span class="fw-bold">{{ data.item.updated_by_name == null ? data.item.created_by_name : data.item.updated_by_name }}</span></p>
                      </div>
                  </template>

                </b-table>
              </div>
            </div>
            <div class="row g-0 text-center" v-if="rolesListTotalRows == 0">
              <span>No data to display.</span>
            </div>
            <!-- end table responsive -->

            <b-modal id="bv-modal-delete" centered title="Delete" hide-footer>
              <div class="text-center pb-4">
                <i class='bx bx-x-circle text-danger' style="font-size:5rem"></i>
                <h3 class="my-2">Are you sure?</h3>
                <p class="mx-4">Do you really want to delete these records? This process cannot be undone!
                </p>

                <b-button class="btn btn-light me-2 px-3" @click="$bvModal.hide('bv-modal-delete')">Cancel
                </b-button>
                <b-button class="btn btn-danger px-4" @click="deleteRole(); $bvModal.hide('bv-modal-delete')">Delete
                </b-button>
              </div>
            </b-modal>
            <!-- </div> -->
            <div class="col-sm-12">
              <div class="row">
                <div class="col">
                  <div class="form-group row pull-left">
                    <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                    <div class="col-sm-6">
                      <b-form-group label-for="display-record">
                        <b-form-select class="form-select shadow-none w-fit" id="display-record" v-model="perPage"
                          :options="pageOptions" @change="getRoles()"></b-form-select>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <!-- pagination -->
                    <b-pagination class="pagination-rounded" v-model="currentPage" :total-rows="rolesListTotalRows"
                      @input="getRoles()" :per-page="perPage"></b-pagination>
                  </div>
                </div>
              </div>
            </div>
            <!-- end row -->
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </div>
</template>
